module.exports = __webpack_public_path__ + "static/media/scroll.f3f37e12.gif";